// Part 1
import { createSlice } from "@reduxjs/toolkit"

// Part 2
export interface AuthInitialState {
  isLoggedIn: boolean;
  user: null | {
    clientName: string;
    clientPermissions: string[];
    isLoginUsingClientUrl: boolean;
    isProfileImageAvailable: boolean;
    isSuperAdminUser: boolean;
    loginURL: string;
    logoutURL: string;
    needToDisplayClientSwitchButton: boolean;
    permissions: string[];
    roleName: string;
    sessionTimeoutSeconds: number;
    subClientPermissions: string[];
    userFullName: string;
    userName: string;
  },
  clientId: string;
  userRole: "client" | "subClient"
}

const initialState: AuthInitialState = {
  isLoggedIn: false,
  user: null,
  clientId: '',
  userRole: "client"
}



// Part 3
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginUser: (state, action) => {
      state.user = action.payload;
    },
    logOut: () => {
      // sessionStorage.clear();
      localStorage.removeItem('user');
      localStorage.removeItem('loggedInUser');
      sessionStorage.removeItem('currentUserId');
      sessionStorage.removeItem('copyMasterButtonModalShow');
      sessionStorage.removeItem('currentSelectedClient');
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload ? true : false;
      // localStorage.setItem('loggedInUser', action.payload)
      sessionStorage.setItem("copyMasterButtonModalShow", "true");
      localStorage.setItem("user", JSON.stringify({ clientId: action.payload, isAuthenticated: action.payload ? true : false }));
      state.clientId = action.payload || localStorage.getItem('loggedInUser')
    },
    isUserAuthenticated: (state) => {
      const isUserLoggedIn = state.isLoggedIn || localStorage.getItem('loggedInUser');
      state.isLoggedIn = isUserLoggedIn ? true : false;
    },
  }
})

// Part 4
export const { loginUser, logOut, updateUser, isUserAuthenticated, setIsLoggedIn } = authSlice.actions
export default authSlice.reducer
